import React from 'react'
import {Helmet} from 'react-helmet'
import {useMutation, useQuery} from '@apollo/client'

import {Button, NakedButton} from '../../../components/Button'
import {CardContainer, Container} from '../../../components/Container'
import {Byline, H1, H2, HR} from '../../../components/Typography'
import {Left} from '../../../components/Header'
import {Loading, LoadingError} from '../../../components/LoadingFork'
import {Table, TBody} from '../../../components/Table'
import {PERMISSIONS} from '../../../lib/authManager'
import {PermissionOnly} from '../../../components/AdminOnly'
import {withInstallation} from '../../../components/InstallationContext'
import {useFormState} from 'react-use-form-state'
import {Header} from '../RateCards/components/common'

import {TextInputRow, avgPickupMinutesOrDefault} from './DetailsForm'
import {defaultLot, updateDefaultLotMutation} from './queries'

function DefaultLotDetails({installation, history}) {
    const {data, loading, error} = useQuery(defaultLot, {
        fetchPolicy: 'no-cache',
        variables: {installationId: installation.id},
    })

    if (loading) return (
        <CardContainer>
            <Loading/>
        </CardContainer>
    )
    if (error) return (
        <CardContainer>
            <LoadingError error={error}/>
        </CardContainer>
    )

    return (
        <CardContainer>
            <Helmet>
                <title>Default</title>
            </Helmet>
            <Container spaceBelow='medium'>
                <Header>
                    <Left>
                        <div>
                            <H1 spaceBelow='none'>Default</H1>
                        </div>
                    </Left>
                </Header>
            </Container>
            <Container spaceAbove='medium' spaceBelow='medium'>
                <H2>Lot details</H2>
                <DefaultLotDetailsForm
                    settings={data.defaultLot}
                    onDone={() => history.goBack()}
                />
            </Container>
        </CardContainer>
    )
}

function DefaultLotDetailsForm({settings, onDone}) {
    const [{errors, values}, {number}] = useFormState({
        avgPickupMinutes: settings.avgPickupMinutes,
    })

    const [updateDefaultLot, {error: submitError}] = useMutation(updateDefaultLotMutation)

    async function onSubmit() {
        await updateDefaultLot({
            variables: {
                installationId: settings.installationId,
                avgPickupMinutes: avgPickupMinutesOrDefault(values.avgPickupMinutes),
            },
        })

        return onDone()
    }

    const hasErrors = Object.values(errors).some((x) => x)

    return <div>
        {submitError && <LoadingError error={submitError}/>}
        {hasErrors && <LoadingError error={Object.values(errors)[0]}/>}

        <HR spaceAbove='medium' spaceBelow='medium'/>

        <Table>
            <TBody>
                <TextInputRow key={"avgPickupMinutes"}
                              {...number('avgPickupMinutes')}
                              rows={1}
                              name={"Average runner pickup time, minutes"}/>
            </TBody>
        </Table>

        <Container>
            <PermissionOnly permissions={PERMISSIONS.PARKING_LOTS_MANAGE}>
                <Button block type='submit' disabled={hasErrors} onClick={onSubmit}>
                    Update card
                </Button>
                {' '}
            </PermissionOnly>
            <NakedButton block flavour='gray' onClick={onDone}>Cancel</NakedButton>
        </Container>
    </div>
}

export default withInstallation(DefaultLotDetails)
